import { render, staticRenderFns } from "./configure-service-charges.vue?vue&type=template&id=b9c2d238&scoped=true"
import script from "./configure-service-charges.vue?vue&type=script&lang=js"
export * from "./configure-service-charges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c2d238",
  null
  
)

export default component.exports